import { FC, useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation, matchPath, useParams } from "react-router-dom";

import HubHeader from '../components/header';
import HubFooter from "../components/footer";
// import GuestTopHeader from "src/components/guestTopHeader";
import TawkToMessengerComp from "src/components/tawk.to";

import { AuthContext } from "../context/authContext";
import { AuthenticatedRoutes, DBMRoutes, KAMLeadsRoutes, ManufacturerRoutes, PNLeadsRoutes, PublicRoutes, RepRoutes, TBMRoutes } from "../routes/AppRoutes";
import { AppRoute } from "src/routes/types";
import { USER_TYPES } from "../constants";
import { parse } from "date-fns";
import CaseProvider from "src/context/caseContext";
import { LOGGED_IN_VIDEO_NAMES } from "src/constants/headerLinks";


const WithHeaderandFooter: FC<{ WrappedComponent: FC }> = ({ WrappedComponent }): JSX.Element => {
  const [mountTawk, updateMount] = useState(false);

  const { isUserAuthorized, isManufacturer, isRestoreCalled, userData, restoreSession } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  //:- specifically for public user
  const { video_name } = useParams();
  const [showBanner, setShowBanner] = useState(false);
  const [closeBanner, setCloseBanner] = useState(true);

  const handleCloseBanner = () => {
    setShowBanner(false); // will reset on refresh or revisit
  };

  const CloseBanner = () => {
    setCloseBanner(false); // will reset on refresh or revisit
  };

  const navigateToTargetedRoute = (RouteListing: AppRoute[]) => {
    const indexRoute = RouteListing.find((route) => route.isIndex);
    const currentRoute = RouteListing.find((route) =>
      matchPath({ path: route.route, end: false }, pathname)
    );

    if (indexRoute) {
      
      if (isManufacturer && userData ) {
        const refType = userData.ref_type?.toLowerCase();
        const routeId = userData.id;

        console.log("navigateToTargetedRoute", { currentRoute, routeId })

        const navigateToIndexRoute = (routes: AppRoute[]) => {

          console.log("navigateToIndexRoute", {  refType, routeId })
          const indexRoute = routes.find((route) => route.isIndex);
          console.log("navigateToIndexRoute", {  refType ,indexRoute})

          if (!indexRoute) return;

          switch (indexRoute.route) {
            case "/tbms/:id":
              navigate(`/tbms/${routeId}`);
              break;

            case "/patientNavigatorLeads/:id":
              navigate(`/patientNavigatorLeads/${routeId}`);
              break;

            case "/kamleads/:id":
              navigate(`/kamleads/${routeId}`);
              break;

            case "/statistics/:id":
              navigate(`/statistics/${routeId}`);
              break;

            default:
              navigate(indexRoute.route);
              break;
          }
        };

        // if (refType === "dbm") {
        //   navigateToIndexRoute(ManufacturerRoutes);
        // } else if (refType === "tbm") {
        //   navigateToIndexRoute(TBMRoutes);
        // } else if (refType === "pn_lead") {
        //   navigateToIndexRoute(PNLeadsRoutes);
        // } else if (refType === "kam_lead") {
        //   navigateToIndexRoute(KAMLeadsRoutes);
        // } else if (["patient_navigator", "kam"].includes(refType)) {
        //   navigateToIndexRoute(RepRoutes);
        // }
      }
      else if (userData && USER_TYPES.HCP.includes(userData.ref_type)) {
                      console.log("navigate to current route", indexRoute + indexRoute.route)

        if (!userData.baa_viewed || (userData.baa_viewed_date && userData.baa_viewed_date.length > 0 && parse(userData.baa_viewed_date, "MM/dd/yyyy", new Date()) > new Date()))
          navigate("/pages/baa")
        else {
          if (currentRoute) {
            if (currentRoute.route.includes("video")) {
              console.log({ LOGGED_IN_VIDEO_NAMES })
              if (video_name && LOGGED_IN_VIDEO_NAMES.includes(video_name))
                navigate(pathname + search);
              else
                navigate(indexRoute.route);
            } else
              navigate(pathname + search);
          } else
            navigate(indexRoute.route);
        }
      } else {
        if (currentRoute) {
          if (currentRoute.route.includes("video")) {
            if (video_name && video_name === "enrollment_tutorial")
              navigate(pathname + search)
            else
              console.log("navigate to current route", indexRoute + indexRoute.route)

              navigate(indexRoute.route)
          } else {
            console.log("navigate to current route", pathname + search)
            navigate(pathname + search);
          }
        }
        else navigate(indexRoute.route);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const checkForAuthentication = useCallback(() => {
    if (!isUserAuthorized) {
      navigateToTargetedRoute(PublicRoutes);
    } else {
      if (userData?.is_password_changed === false) {
        navigate("/users/createuser");
      } else if (userData?.ref_type === "Manufacturer" && isManufacturer) {
        navigateToTargetedRoute(ManufacturerRoutes);
      } else if (userData?.ref_type === "dbm" && isManufacturer) {
        navigateToTargetedRoute(DBMRoutes);
      } else if (userData?.ref_type === "tbm" && isManufacturer) {
        navigateToTargetedRoute(TBMRoutes);
      } else if (userData?.ref_type === "pn_lead" && isManufacturer) {
        navigateToTargetedRoute(PNLeadsRoutes);
      } else if (userData?.ref_type === "kam_lead" && isManufacturer) {
        navigateToTargetedRoute(KAMLeadsRoutes);
      } else if (userData && (["patient_navigator", "kam","rep"].includes(userData.ref_type.toLowerCase())) && isManufacturer) {
        navigateToTargetedRoute(RepRoutes);
      }
      else {
        navigateToTargetedRoute(AuthenticatedRoutes);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthorized]);

  useEffect(() => {
    if (isRestoreCalled) {
      checkForAuthentication();
    } else if (!userData) {
      restoreSession();
    } else {
      navigate(pathname + search);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkForAuthentication, isRestoreCalled]);

  useEffect(() => {
    if (isUserAuthorized && userData && !USER_TYPES.MANUFACTURER.includes(userData.ref_type)) updateMount(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthorized]);



  return (
    <>
      <header className="sticky-top"><HubHeader /></header>
      {showBanner && !isManufacturer && (
        <div className="alert alert-warning auto-save-banner d-none">
          We have added a new auto save feature that allows you to draft a Prescription Start Form submission and
          complete at a later time or date.
          <button type="button" className="btn bi bi-x-lg" onClick={handleCloseBanner}></button>
        </div>
      )}
      {isUserAuthorized && !isManufacturer && closeBanner && (
        <div className="alert feature-banner auto-save-banner d-none">
          We are pleased to inform you that effective December 28th, 2025, Afrezzahas been approved for a new
          indication. Please click on the AfrezzaFull Prescribing Information link to learn more.
          {/* <a className="ms-2" href="https://www.furoscix.com/wp-content/uploads/prescribing-information.pdf"
                 target="_blank">
                 http://www.Furoscix.com/prescribing-information.pdf
              </a> */}
          <button type="button" className="btn bi bi-x-lg text-primary" onClick={CloseBanner}></button>
        </div>
      )}

      {pathname === "/cases/new" || pathname.includes("clone") ? (
        <CaseProvider>
          <WrappedComponent />
        </CaseProvider>
      ) : (
        <WrappedComponent />
      )}
      {mountTawk ? <TawkToMessengerComp /> : null}
      <HubFooter />
    </>
  );
}


export default WithHeaderandFooter;
